import Modal from './modal.js';


$(document).ready(function() {

	$(document).on('click', '.merge-users', function(e) {
		e.preventDefault();

        Modal.openModal('.modal-merge-user');

	});

    $(document).on('click', '.delete-user-btn', function(e) {
        e.preventDefault();

        Modal.openModal('.modal-delete-user');

    });

	//$(document).on('click', '#select-user-link-button', function(e) {
	$( ".user-select" ).change(function(e) {
        e.preventDefault();

        var userId = $('option:selected', ".user-select").val();

		$.ajax({
		  url: window.site.url + '/api/user',
		  method: 'GET',
		  data: {
		    id: userId
		  },
		  success: function( response ) {
		  	console.log(response);
		     setUserInputs(response);
		     $("#userLinkModal .close-modal").click();
		  }
		});
	});

	function setUserInputs(response){
		$('#guest-first-name').val(response.first_name + " " + response.surname);
		$('#guest-surname').val(response.first_name + " " + response.surname);
		$('#guest-email').val(response.email);
		$('#guest-company').val(response.company);
		$('#user-id').val(response.id);
	}


	$(document).on('click', '.end-visit', function(e) {
        e.preventDefault();

        Modal.openModal('.modal-end-visit');

		$('.end-visit-confirm').attr('href', $(this).attr('href'));
	});

    $(document).on('click', '.log-user-out', function(e) {
        e.preventDefault();

        Modal.openModal('.modal-log-user-out');

        $('.log-user-out-confirm').attr('href', $(this).attr('href'));
    });




	// Add filename to upload field
	$('.input-upload').change(function() {
        var filename = $('.input-upload').val().split('\\').pop();
        $('.input-placeholder-text').text(filename);
    });

    $('.profile-image').click(function() {
        // var filename = $('.input-upload1').val().split('\\').pop();
        // $('.input-placeholder-text').text(filename);
        $('.input-upload').trigger('click');
    });


    $('.guest-select').wrap('<div class="modal-select-with-dropdown-arrow"></div>');

    $('.filter-guests-btn').click(function() {
        Modal.openModal('.filter-modal');
    });

});


// WEBPACK FOOTER //
// ./users.js